import EmployerProfile from "./EmployerProfile";

export { EmployerProfile as default };
